import { render, staticRenderFns } from "./DevAllot.vue?vue&type=template&id=50532140&scoped=true"
import script from "./DevAllot.vue?vue&type=script&lang=js"
export * from "./DevAllot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50532140",
  null
  
)

export default component.exports